import { render } from "./NoCredits.vue?vue&type=template&id=5b320544"
import script from "./NoCredits.vue?vue&type=script&lang=js"
export * from "./NoCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__